import type { TLayoutsProbe } from './filterOrganizationsWithLayouts';

type TProbeQueryState = {
  isError: boolean;
  errorUpdateCount: number;
  data: { count: number } | undefined;
};

export const classifyLayoutsProbe = ({ isError, errorUpdateCount, data }: TProbeQueryState): TLayoutsProbe => {
  if (data) {
    return { status: 'success', count: data.count };
  }
  if (isError || errorUpdateCount > 0) {
    return { status: 'error' };
  }
  return { status: 'pending' };
};
